export const sortByStartDate = (array: any[], moveUndefinedToEnd: boolean) => {
    return array
        .map((item, index) => ({ ...item, originalIndex: index }))
        .sort((a, b) => {
            const aHasDate = Boolean(a.startDate);
            const bHasDate = Boolean(b.startDate);

            if (!aHasDate && !bHasDate) {
                return b.originalIndex - a.originalIndex;
            }

            if (!aHasDate) return moveUndefinedToEnd ? 1 : -1;
            if (!bHasDate) return moveUndefinedToEnd ? -1 : 1;

            return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
        })
        .map(({ originalIndex, ...rest }) => rest);
};

export const sortFields = (state: any) => {
    Object.keys(state.activeFields).forEach((key) => {
        state.activeFields[key] = sortByStartDate(state.activeFields[key], false);
    });

    Object.keys(state.historyFields).forEach((key) => {
        state.historyFields[key] = sortByStartDate(state.historyFields[key], true);
    });
    console.log(state.activeFields);
};
